import React, { useEffect, useState } from "react";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import { useRecoilValue } from "recoil";
import { scopePreferenceState, activeScopeState } from "../../global-state";

const Temperature1Widget = ({ widget, onValueUpdate }) => {
  const [temperature, setTemperature] = useState(0);
  const [unit, setUnit] = useState("C");
  const [isFlashing, setIsFlashing] = useState(false);
  const scopePreference = useRecoilValue(scopePreferenceState);
  const activeScope = useRecoilValue(activeScopeState);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const valueStr = widget.items.$w1.value;
      const numericValue = parseFloat(valueStr.replace(/[^0-9.-]/g, ""));
      const preferredUnit =
        scopePreference?.[activeScope]?.temperatureUnit || "C";
      const targetUnit = preferredUnit || widget.items.$w1.unit;
      setUnit(targetUnit);

      // Convert to target unit if needed
      let convertedTemp = numericValue;
      if (valueStr.toUpperCase().includes("F") && targetUnit === "C") {
        // Convert F to C
        convertedTemp = ((numericValue - 32) * 5) / 9;
      } else if (valueStr.toUpperCase().includes("C") && targetUnit === "F") {
        // Convert C to F
        convertedTemp = (numericValue * 9) / 5 + 32;
      }

      setTemperature(convertedTemp);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div
      className="flex items-center justify-center gap-2 w-full border rounded-2xl transition-colors duration-500"
      style={{
        height: "40px",
        borderColor: isFlashing ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      <ThermostatIcon
        style={{
          fontSize: "1.2rem",
        }}
      />
      <span className="text-[0.925rem] font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {temperature.toFixed(1)} °{unit}
      </span>
    </div>
  );
};

export default Temperature1Widget;
